import { Injectable } from "@angular/core";
import { Subject } from "rxjs/Subject";
import * as _ from "lodash";
import { Observable } from "rxjs/Observable";
@Injectable()
export class ActionUpdaterService {
    // Observable string sources
    public successSource = new Subject<string>();
    public clearSource = new Subject<boolean>();
    public errorSource = new Subject<ApiError[]>();

    // Observable string streams
    success$ = this.successSource.asObservable();
    clear$ = this.clearSource.asObservable();

    // Asynchronous container
    public errors = new Subject<Array<ApiError>>();

    constructor() {}

    // DO NOT ADD ANY TIMEOUT
    announceSuccess(msg: string) {
        this.clearSource.next(true);
        this.successSource.next(msg);
    }
    // DO NOT ADD ANY TIMEOUT
    announceError(msg: ApiError) {
        this.errors.next([msg]);
    }
    // DO NOT ADD ANY TIMEOUT
    announceErrors(msg: ApiError[]) {
        this.errors.next(msg);
    }
    // DO NOT ADD ANY TIMEOUT
    announceClear(msg: boolean) {
        this.errors.next([]);
        this.clearSource.next(msg);
    }

    // Should transition everything to ApiServerError
    onError = (error: ApiServerError | ApiError) => {
        let errorToAnnounce = new ApiError();
        if (_.has(error, "ErrorSummary")) {
            const apiServerError = error as ApiServerError;
            errorToAnnounce.summary = apiServerError.ErrorSummary;
            errorToAnnounce.details = !!apiServerError.Message
                ? [apiServerError.Message]
                : apiServerError.Errors.map(v => v.Value);
        } else {
            errorToAnnounce = error as ApiError;
        }
        this.announceError(errorToAnnounce);
    };
}

export class ApiError {
    constructor(
        public summary?: string,
        public details?: Array<string>,
        public message?: string
    ) {
        if (!!message && message.length > 0) {
            this.details = [message];
        }
    }
}

export class ApiServerError {
    constructor(
        public ErrorSummary: string,
        public Message: string,
        public Errors?: Array<ErrorKeyValue>
    ) {}
}

export class ErrorKeyValue {
    public Key: string;
    public Value: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/services/action-updater.service.ts